import { BRAND } from "@/data/site";
import { cn } from "@/lib/utils";

// The DuckTheBugs mascot as a restrained brand badge, optionally with a
// speech bubble for playful micro-copy ("Duck's Take", "Quick Verdict").
export function DuckBadge({ size = 48, className = "", ring = true }) {
  return (
    <img
      src={BRAND.logo}
      alt="DuckTheBugs mascot"
      width={size}
      height={size}
      loading="lazy"
      className={cn(
        "object-cover rounded-full bg-sand",
        ring && "ring-2 ring-forest/15 shadow-sm",
        className
      )}
      style={{ width: size, height: size }}
    />
  );
}

export function DuckSays({ children, label = "Duck's Take", className = "" }) {
  return (
    <div className={cn("flex items-start gap-4", className)} data-testid="duck-says">
      <DuckBadge size={56} />
      <div className="relative rounded-2xl rounded-tl-sm bg-forest text-cream px-5 py-4 max-w-md">
        <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-duckgreen">{label}</span>
        <p className="mt-1 text-sm leading-relaxed text-cream/90">{children}</p>
      </div>
    </div>
  );
}
